import { ListItem } from "../Helpers/ListView/ListItem";
import { RootState, useAppSelector } from "../../data/store/store";
import { useParams } from "react-router-dom";

export default function useFindById<T extends ListItem>(selector: (state: RootState) => T[]): T | undefined {
    const items = useAppSelector(selector);
    const { id } = useParams();
    const idValue = Number(id);
    return items.find((item: T) => item.id === idValue);
}